(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maccinare-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initAll() {
      document.querySelectorAll('[data-mcm-id]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor: re-init cuando se recarga la sección
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector ? e.target.querySelector('[data-mcm-id]') : null;
      if (sec) initSection(sec);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      // Limpia modales movidos al body para evitar duplicados
      var sec = e.target.querySelector ? e.target.querySelector('[data-mcm-id]') : null;
      if (!sec) return;
      var uid = sec.getAttribute('data-mcm-id');
      document.querySelectorAll('body > .mcm-modal[data-mcm-owner="' + uid + '"]').forEach(function (m) {
        m.parentNode.removeChild(m);
      });
      document.body.classList.remove('mcm-noscroll');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('width');
    });

    function initSection(section) {
      if (section.dataset.mcmInit === '1') return;
      section.dataset.mcmInit = '1';

      var uid = section.getAttribute('data-mcm-id');
      var openButtons = section.querySelectorAll('[data-mcm-open]');
      var lastFocused = null;
      var savedScrollY = 0;

      // CRÍTICO: mover modales al <body> para escapar ancestros transformados
      // (sin esto, position:fixed se ancla al ancestro y el modal queda off-screen
      // al hacer scroll, dejando body bloqueado y aparentemente "congelado").
      section.querySelectorAll('[data-mcm-modal]').forEach(function (modal) {
        modal.setAttribute('data-mcm-owner', uid);
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
        modal.querySelectorAll('[data-mcm-close]').forEach(function (el) {
          el.addEventListener('click', function (ev) {
            ev.preventDefault();
            closeModal(modal);
          });
        });
      });

      openButtons.forEach(function (btn) {
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          var id = btn.getAttribute('data-mcm-open');
          var modal = document.getElementById(id);
          if (modal) openModal(modal, btn);
        });
      });

      // ESC global (cierra cualquier modal abierto de esta sección)
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var open = document.querySelector('.mcm-modal.is-open[data-mcm-owner="' + uid + '"]');
        if (open) closeModal(open);
      });

      // Focus trap
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var open = document.querySelector('.mcm-modal.is-open[data-mcm-owner="' + uid + '"]');
        if (!open) return;
        var focusables = getFocusable(open);
        if (focusables.length === 0) { e.preventDefault(); return; }
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      });

      function openModal(modal, opener) {
        lastFocused = opener || document.activeElement;
        // iOS Safari scroll lock: guarda posición, fija body
        savedScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.classList.add('mcm-noscroll');
        document.body.style.top = '-' + savedScrollY + 'px';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');

        setTimeout(function () {
          var first = getFocusable(modal)[0];
          if (first) first.focus();
        }, 50);
      }

      function closeModal(modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');

        document.body.classList.remove('mcm-noscroll');
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('width');
        window.scrollTo(0, savedScrollY);

        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }

      function getFocusable(container) {
        return Array.prototype.slice.call(container.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
